import { filter as _filter } from 'lodash';
import { find as _find } from 'lodash';

class DeliveryPriceContainerController {
  constructor($stateParams, lookupService, $q, loadingService, deliveryPriceManagementService) {
    "ngInject";

    this.lookupService = lookupService;
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.loadingService = loadingService;
    this.deliveryPriceManagementService = deliveryPriceManagementService;

    this.errMsg = '';
    this.deliveryPriceList = [];
    this.deliveryPrice = {};

    this.reset();
    this.init();    
  }

  reset() {
    this.deliveryPrice = {
      entityId: this.$stateParams.locationId,
      brandId: 1,
      brandModelId: null,
      price: null
    }    

    this.errMsg = '';
  }

  init() {
    const ctrl = this;

    ctrl.loadingService.showLoading('container', 'Loading Delivery Prices');

    ctrl.initializeLookups()
      .then(() => {
        ctrl.deliveryPriceManagementService.listDeliveryPrices(ctrl.$stateParams.locationId)
          .then((response) => {
            ctrl.deliveryPriceList = response.data.items;

            ctrl.loadingService.hideLoading('container');
          });        
      });
  }

  initializeLookups() {
    const ctrl = this;
    const deferred = this.$q.defer();

    this.lookupService.lookupBrands()
      .then(brands => {
        this.allBrands = brands;

        this.lookupService.lookupBrandModels()
          .then(brandModels => {            
            this.allBrandModels = brandModels;            
            this.updateBrandModel();

            deferred.resolve();
        });
    });

      return deferred.promise;
  }  

  add() {
    if (!this.validateAdd()) {
      return;
    }

    this.loadingService.showLoading('container', 'Adding new Delivery Price ...');

    this.deliveryPriceManagementService.addDeliveryPrice(this.deliveryPrice)
    .then((response) => {
      this.reset();
      this.init();
      this.loadingService.hideLoading('container');
    });        
  }  
  
  validateAdd() {    
    if (!this.deliveryPrice.price || !Number.isInteger(parseInt(this.deliveryPrice.price))) {
      this.errMsg = 'Delivery Price must be a valid number';
      return false;
    }

    const dup = _find(this.deliveryPriceList, o => o.brandId === this.deliveryPrice.brandId && o.brandModelId == this.deliveryPrice.brandModelId);

    if (dup) {
      this.errMsg = `Delivery Price for ${dup.brandName} ${dup.brandModelName} already exists`;
      return false;      
    }

    return true;
  }

  remove(deliveryPriceId) {
    const sure = window.confirm('Are you sure you want to remove this delivery price');

    if (!sure){
      return;

    }
    this.loadingService.showLoading('container', 'Removing Delivery Price ...');

    this.deliveryPriceManagementService.removeDeliveryPrice(this.$stateParams.locationId, deliveryPriceId)
    .then((response) => {
      this.init();
      this.loadingService.hideLoading('container');
    });        
  }   

  updateBrandModel() {
    this.brandModels = _filter(this.allBrandModels, o => o.brandId === this.deliveryPrice.brandId);    
    this.brandModels.unshift({brandModelId: null, name: 'All'});
  }  

  
}

export default DeliveryPriceContainerController;



// WEBPACK FOOTER //
// ./client/app/components/admin/deliveryPriceManagement/deliveryPriceContainer/deliveryPriceContainer.controller.js